import { formatDate, formatNumber } from '@angular/common';
import { CmpsCardRowTooltipValue } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { WpCoachingCard } from '../models/wp-coaching-card.model';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

function getLastUpdateStr(value?: string, userLocale?: string): string {
    if (value != null) {
        const date = new Date(
            value.trim().toLowerCase().endsWith('z') ? value : `${value}Z`,
        );
        return formatDate(date, 'MMMM d, YYYY, hh:mm a', userLocale);
    }
    return 'null';
}
export function getWinningPctTooltipData(
    wpCard: WpCoachingCard,
): CmpsCardRowTooltipValue[] {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);
    const userLocale = i18nService.locale;

    return [
        {
            label: translateService.instant(
                TranslationKeyMap._10103_TOTAL_EVENTS,
            ),
            value: formatNumber(wpCard.total ?? 0, userLocale, '1.0'),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._10104_NUMBER_WINNING,
            ),
            value: formatNumber(wpCard.winningNumber ?? 0, userLocale, '1.0'),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._10098_NUMBER_LOSING,
            ),
            value: formatNumber(wpCard.losingNumber ?? 0, userLocale, '1.0'),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._10099_NUMBER_NEUTRAL,
            ),
            value: formatNumber(wpCard.neutralNumber ?? 0, userLocale, '1.0'),
        },
        {
            label: translateService.instant(
                TranslationKeyMap._10080_COACHING_EVENT_RANGE,
            ),
            value: wpCard.dataRangeName,
        },
        {
            label: translateService.instant(
                TranslationKeyMap._10082_EVALUATION_RANGE,
            ),
            value: wpCard.evaluationRangeName,
        },
        {
            label: translateService.instant(
                TranslationKeyMap._9923_LAST_UPDATED,
            ),
            value: getLastUpdateStr(
                wpCard.createdOn as any as string,
                userLocale,
            ),
        },
    ];
}
